import React from "react";
import { useTranslation } from 'react-i18next';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PlaceIcon from '@mui/icons-material/Place';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import { HouseOutlined, LanguageOutlined, Web, WebStoriesOutlined, WorkHistoryRounded } from "@mui/icons-material";

export const Contact = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Typography variant="h6" component="h2">
            {t('ContactInformation')}
          </Typography>
          <div
            style={{
              // textAlign: "center",
            }}
          >
        <p><HouseOutlined/>4165-768-875</p>
        <p>Space Science and Geospatial Institute </p>
        <p><PlaceIcon />  Menelik II Avenue, Addis Ababa, Ethiopia</p>
        <p><CallIcon /> +251 118 96 10 50/ +251 115 51 84 45</p>

        <p><EmailIcon />contact@ssgi.gov.et</p>
        <p><LanguageOutlined />www.ssgi.gov.et</p>
        <p>
          {t('WorkingHours')}
        </p>
          </div>
         
        </Box>
      </Box>
    </Modal>
  );
};
